<div
  *ngIf="isDirectApplicant$ | async"
  class="move-forward-icon"
  (click)="moveForwardButtonClicked()"
  data-cy="move-forward-icon"
  matTooltip="Move forward"
>
  <mat-icon>forward</mat-icon>
</div>
